import { Box, Grid, Typography, useTheme } from "@mui/material";
import React from "react";
import tunnelImage from "../../../../../media/images/courseCover.png";
import ArrowLeftSVG from "../../../../../media/images/icons/arrow-left";
import { Link } from "react-router-dom";
export default function CourseCard() {
  const theme = useTheme();

  return (
    <Grid
      sx={{
        marginX: "auto",
        marginTop: "8px",
        paddingX: "12px",
        paddingY: "16px",
        borderRadius: "16px",
        // border: "1px solid gray",
        display: "flex",
        justifyContent: "space-between",
        backgroundColor: "background.default",
        boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
      }}
      container
      sm={5.8}
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          gap: "16px",
          flexDirection: {
            sm: "column-reverse",
          },
        }}
      >
        <Box>
          <Typography
            sx={{
              fontWeight: "bolder",
              fontSize: "16px",
              marginTop: {
                xs: "0px",
                sm: "8px",
              },
            }}
          >
            آموزش ویدئویی ایجاد بار جدید برای صاحبان کالا
          </Typography>
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "bolder",
              display: {
                xs: "none",
                sm: "block",
              },
            }}
          >
            در این ویدئوی آموزشی درباره روش های امتیاز گیری در باشگاه مشتریان
            توضیح داده ایم...
          </Typography>
          <Link
            style={{
              textAlign: "center",
              marginTop: "8px",
              backgroundColor: theme.palette.secondary.dark,
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "space-between",
              padding: "8px 12px",
              borderRadius: "12px",
            }}
            to={"1"}
          >
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "15px",
                color: "background.default",
              }}
            >
              مشاهده ویدئو
            </Typography>
            <ArrowLeftSVG size={28} />
          </Link>
        </Box>
        <Box
          sx={{
            width: {
              xs: "70%",
              sm: "100%",
            },
            display: "flex",
            flexDirection: "column",
            gap: "4px",
          }}
        >
          <img
            style={{
              width: "100%",
              objectFit: "cover",
            }}
            src={tunnelImage}
            alt=""
          />
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "bolder",

              display: {
                sm: "none",
              },
            }}
          >
            در این ویدئوی آموزشی درباره روش های امتیاز گیری در باشگاه مشتریان
            توضیح داده ایم...
          </Typography>
        </Box>
      </Box>
    </Grid>
  );
}
